import LocalAttachmentsService from "@mirage/services/LocalAttachmentsService";
import { DownloadAttachmentResult } from "@shared/mirage/core/contracts/IAttachment";
import { useCallback } from "react";
import useAlertService from "./useAlertService";

export const useDownloadAttachment = (
    service: LocalAttachmentsService
): [(attachmentId: number, onlyReturnAtt?: boolean) => Promise<DownloadAttachmentResult | null>, LocalAttachmentsService] => {
    const showAlert = useAlertService();
    const onDownload = useCallback(async (attachmentId: number, onlyReturnAtt = false) => {
        const result = await service.DownloadAttachment(attachmentId);
        if (!result) {
            showAlert("File not found", "error");
        } else if (!onlyReturnAtt && result) {
            window.location.assign(result.url);
        }
        return result;
    }, []);

    return [onDownload, service];
};
